import axios from "axios";

export default {

  menuIsOpen: false,
  desktopMenuHover: null,
  $window: null,
  $body: null,

  init() {

    this.$window = $(window);
    this.$body = $('body');

    /**************************************************/
    // page resize detection
    /**************************************************/
    const onResize = () => {
      // header resize
      // this.root.style.setProperty('--main-header-height', $mainHeader.outerHeight() + 'px');
      /*if (window.matchMedia('(max-width: '+($mainHeader.hasClass('retailers') ? 1200 - 1 : 992 - 1)+'px)').matches) { // --breakpoint-xl | --breakpoint-lg
        if (window.matchMedia('(min-width: 992px)').matches) { // --breakpoint-lg
      }*/

      // if site is included into an iframe report resize events, useful for quick-view mode
      try {
        if(this.inIframe()) {
          parent.$('body').trigger('iframeContentResize', [$('body').outerHeight()]);
        }
      } catch (e) {}

    };

    $(window).on('resize.global orientationchange.global', onResize);
    onResize();


    /*
    const documentComputedStyle = getComputedStyle(document.documentElement, null);
    window.SigmaGI.breakpoints = {
      xs: documentComputedStyle.getPropertyValue('--breakpoint-xs'),
      sm: documentComputedStyle.getPropertyValue('--breakpoint-sm'),
      md: documentComputedStyle.getPropertyValue('--breakpoint-md'),
      lg: documentComputedStyle.getPropertyValue('--breakpoint-lg'),
      xl: documentComputedStyle.getPropertyValue('--breakpoint-xl'),
    };
    */

    /**************************************************/
    // page scroll detection
    /**************************************************/

    const onPageScroll  = () => {

    };

    $(window).on('scroll.pageScroll resize.pageScroll orientationchange.pageScroll', onPageScroll);
    onPageScroll();

    /**************************************************/
    // init menu
    /**************************************************/
    this.initMenu();

    /**************************************************/
    // init search
    /**************************************************/
    this.initSearch();

    /**************************************************/
    // init language selectors
    /**************************************************/
    this.initLanguagesSelectors();

    /**************************************************/
    // init pagination dropdowns
    /**************************************************/
    this.initPagination();

    this.megaMenu();


    /**************************************************/
    // handle form extra fields for Italy (SDI, PEC)
    /**************************************************/
    this.handleItalyExtraFields();

    this.initCartCountUpdates();
    this.initVideoController();

  },

  finalize() {

  },

  megaMenu(){
    var windowWidth = $(window).width();

    $("#woman").on("mouseenter", function(){
        $(".W").addClass("mega-menu-show")
        $(".M").removeClass("mega-menu-show")
        $(".K").removeClass("mega-menu-show")
        $("#mega-menu-macro").addClass("mega-menu-show")
        $("#searchForm").addClass("not-show")


    })
    $("#mega-menu-macro").on("mouseleave", function(){
        $(".W").removeClass("mega-menu-show")
        $("#mega-menu-macro").removeClass("mega-menu-show")
        $("#searchForm").removeClass("not-show")

    })

    $("#man").on("mouseenter", function(){
        $(".M").addClass("mega-menu-show")
        $(".W").removeClass("mega-menu-show")
        $(".K").removeClass("mega-menu-show")
        $("#mega-menu-macro").addClass("mega-menu-show")
        $("#searchForm").addClass("not-show")

    })
    $("#mega-menu-macro").on("mouseleave", function(){
        $(".M").removeClass("mega-menu-show")
        $("#mega-menu-macro").removeClass("mega-menu-show")
        $("#searchForm").removeClass("not-show")

    })

    $("#kid").on("mouseenter", function(){
        $(".K").addClass("mega-menu-show")
        $(".M").removeClass("mega-menu-show")
        $(".W").removeClass("mega-menu-show")
        $("#mega-menu-macro").addClass("mega-menu-show")
        $("#searchForm").addClass("not-show")

    })
    $("#mega-menu-macro").on("mouseleave", function(){
        $(".K").removeClass("mega-menu-show")
        $("#mega-menu-macro").removeClass("mega-menu-show")
        $("#searchForm").removeClass("not-show")

    })


    $("#mega-menu-macro").on("mouseenter", function(){
      $("#searchForm").addClass("not-show")
    })
    $("#mega-menu-macro").on("mouseleave", function(){
      $("#searchForm").removeClass("not-show")
    })

    

    // $(".top-stripe ").on("mouseenter", function(){
    //     $(".K").removeClass("mega-menu-show")
    //     $(".M").removeClass("mega-menu-show")
    //     $(".W").removeClass("mega-menu-show")
    //     $("#mega-menu-macro").removeClass("mega-menu-show")
    // })

    // $("#sales").on("mouseenter", function(){
    //     $(".K").removeClass("mega-menu-show")
    //     $(".M").removeClass("mega-menu-show")
    //     $(".W").removeClass("mega-menu-show")
    //     $("#mega-menu-macro").removeClass("mega-menu-show")
    // })

    // $("#brands").on("mouseenter", function(){
    //     $(".K").removeClass("mega-menu-show")
    //     $(".M").removeClass("mega-menu-show")
    //     $(".W").removeClass("mega-menu-show")
    //     $("#mega-menu-macro").removeClass("mega-menu-show")
    // })

    if (windowWidth < 1400) {
        $("#man").on("click", function(){
            event.preventDefault();
            $("#accordion-M").slideToggle("slow")
            $("#accordion-K").slideUp("slow")
            $("#accordion-W").slideUp("slow")

            $("#man-chev").toggleClass("chev-rotate")
            $("#woman-chev").removeClass("chev-rotate")
            $("#kid-chev").removeClass("chev-rotate")

        })

        $("#woman").on("click", function(){
            event.preventDefault();
            $("#accordion-W").slideToggle("slow")
            $("#accordion-K").slideUp("slow")
            $("#accordion-M").slideUp("slow")

            $("#woman-chev").toggleClass("chev-rotate")
            $("#man-chev").removeClass("chev-rotate")
            $("#kid-chev").removeClass("chev-rotate")

        })

        $("#kid").on("click", function(){
            event.preventDefault();
            $("#accordion-K").slideToggle("slow")
            $("#accordion-W").slideUp("slow")
            $("#accordion-M").slideUp("slow")

            $("#kid-chev").toggleClass("chev-rotate")
            $("#man-chev").removeClass("chev-rotate")
            $("#woman-chev").removeClass("chev-rotate")


        })
    }

},

  initVideoController() {
    $(document).on("click", "#videoBanner .close", function() {
      $("#videoBanner").removeClass("show");
      var cname = "viewed";
      var cvalue = 1;
      // var d = new Date();
      // d.setTime(d.getTime() + (1*24*60*60*1000));
      // var expires = "expires="+ d.toUTCString();
      // document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
      document.cookie = cname + "=" + cvalue + ";path=/";
      window.setTimeout( function() { $("#videoBanner").css({"display":"none"}); }, 300 );
    });

    $(document).on("click", "#videoBanner", function() {
      $("#videoBanner").removeClass("show");
      var cname = "viewed";
      var cvalue = 1;
      // var d = new Date();
      // d.setTime(d.getTime() + (1*24*60*60*1000));
      // var expires = "expires="+ d.toUTCString();
      // document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
      document.cookie = cname + "=" + cvalue + ";path=/";
      window.setTimeout( function() { $("#videoBanner").css({"display":"none"}); }, 300 );
    });

    
  },

  initCartCountUpdates() {

    const onUpdate = (event, count) => {
      const $counter = $('.cart .counter');

      if (count)
        $counter.removeClass('empty');
      else
        $counter.addClass('empty');

      $counter.html(count);
    };
    $(window).on('updateCartContent', onUpdate);


    $(window).on('doUpdateCartContent.global', () => {

      axios.post(window.CART.updateCount)
        .then((response) => {

          if (response.status === 200 && response.statusText === 'OK') {
            try {
              const $target = this.inIframe() ? parent.$('body') : $(window);
              $target.trigger('updateCartContent', [response.data.total]);
            } catch (e) {}
          }

        })
        .catch((error) => {});

    });

  },

  initMenu() {
    const $mobileMenuHamburger = $('#mobileMenuHamburger');

    $mobileMenuHamburger.on('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();

      $mobileMenuHamburger.toggleClass('is-active');
      this.updateMenuVisibility();
    });
  },

  updateMenuVisibility() {
    const $mobileMenuHamburger = $("#mobileMenuHamburger");
    const $menuPanel = $("#mainMenu");
    const $menuCurtain = $("#globalnav-curtain");
    const $body = $("body");

    if ($mobileMenuHamburger.hasClass("is-active")) {
      $body.addClass("menu--is-active");

      $menuPanel.addClass("is-active--start");
      setTimeout(function() {
        $menuPanel.addClass("is-active");
        $menuCurtain.addClass("is-active");
        $menuPanel.removeClass("is-active--start");
      }, 0);
    } else {
      $body.removeClass("menu--is-active");

      $menuPanel.addClass("is-active--start");
      $menuPanel.removeClass("is-active");
      $menuCurtain.removeClass("is-active");
      setTimeout(function() {
        $menuPanel.removeClass("is-active--start");
      }, 300);
    }
  },

  initSearch() {
    const $searchButton = $('#searchButton');
    const $searchButtonDesk = $('#searchButtonDesk');
    const $searchFormContainer = $('#searchForm');
    const $form = $searchFormContainer.find('form');
    const $searchWords = $('#searchWords');
    const $searchPlaceholder = $('#searchPlaceholder');
    const $resetSearch = $('.remove-search');

    $searchWords.on('focus', (e) =>  {
      $searchPlaceholder.addClass('hidden');
    }).on('blur', (e) => {
      if($searchWords.val().trim() == '') {
        $searchPlaceholder.removeClass('hidden');
      }
    });

        const toggleSearchForm = () => {
      const isActive = $searchFormContainer.hasClass('is-active');
      if(isActive) {
        $searchFormContainer.addClass('is-active--start');
        $searchFormContainer.removeClass('is-active');

        setTimeout(() => {
          $searchFormContainer.removeClass('is-active--start');
        }, 300);
      }
      else {
        $searchFormContainer.addClass('is-active--start');
        $searchWords.trigger('focus');

        setTimeout(function() {
          $searchFormContainer.addClass('is-active');
          $searchFormContainer.removeClass('is-active--start');

          setTimeout(() => {
            $searchWords.trigger('touchstart');
          }, 300);
        }, 10);
      }
        };

        $searchButton.click((e) => {
          toggleSearchForm();
    });
    $searchButtonDesk.click((e) => {
      toggleSearchForm();
});

    // show search form if a search has been performed
    if($searchWords.val() != '') {
      $searchFormContainer.addClass('is-active');
    }

    $searchWords.on('change keydown keypress keyup mousedown click mouseup', e => {
            if($searchWords.val() === '')
        $resetSearch.removeClass('show');
            else
              $resetSearch.addClass('show');
    });

    $resetSearch.on('click', e => {
      e.preventDefault();

      $searchWords.val('');
      $form.submit();

            $resetSearch.removeClass('show');
            toggleSearchForm();
    });

    const onPageScroll  = () => {
      if(this.$window.scrollTop() > 100)
        this.$body.addClass('scroll');
      else
        this.$body.removeClass('scroll');
    };

    this.$window.on('scroll.pageScroll resize.pageScroll orientationchange.pageScroll', onPageScroll);
    onPageScroll();

  },

  initLanguagesSelectors() {
    $('.language-dropdown').change((e) => {
      window.location = $(e.currentTarget).val();
    });
  },

  initPagination() {
    $('select.pagination-pages-dropdown').change((e) => {
      window.location = $(e.currentTarget).val();
    });
  },

  handleItalyExtraFields() {
    const $countrySelect = $('#country_id');
    const $hideRow = $('.hide-row');

    if($countrySelect.val() == '110') {
      $hideRow.addClass('animate-in').addClass('in');
    }

    $countrySelect.on('change', e => {

      //IT id = 110
      if(e.target.value === '110') {

        if(!$hideRow.hasClass('in')) {

          $hideRow.addClass('animate-in');
          setTimeout(() => {
            $hideRow.addClass('in');
          }, 300);

        } else {

          $hideRow.removeClass('in');
          setTimeout(() => {
            $hideRow.removeClass('animate-in');
          }, 300);
        }
      } else {

        $hideRow.removeClass('in');
        setTimeout(() => {
          $hideRow.removeClass('animate-in');
        }, 300);
      }
    });
  },

  inIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  },

};
